import CryptoJS from 'crypto-js';
const SECRET_KEY_API = process.env.REACT_APP_ENCRYPTION_SECRET;

export const encryptApiData = (value = {}) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(value),
    SECRET_KEY_API
  ).toString();
};

export const decryptApiData = (data) => {
  const { REACT_APP_ENCRYPTION_SECRET } = process.env;
  try {
    if (!data) return {};
    const decryptedBytes = CryptoJS.AES.decrypt(
      data, SECRET_KEY_API
    );
    let test = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(test);
  } catch (e) {
    return {};
  }
};


export function queryStringToJSON(queryString = "") {
  // Remove the leading "?" if present in the query string
  if (queryString.startsWith("?")) {
    queryString = queryString.slice(1);
  }

  // Split the query string into key-value pairs
  const pairs = queryString.split("&");

  // Convert each pair into a key-value object
  const result = {};
  pairs?.forEach((pair) => {
    // Decode each key and value to handle encoded characters like "%3A"
    const [key, value] = pair.split("=").map(decodeURIComponent);

    // Convert string numbers to actual numbers in the result object
    result[key] = value;
  });

  return result;
}
